export const THEMES_KEYS = {
    HEADER: {
        HEADER_COLOR: 'headerColor',
        TEXT_COLOR: 'textColor',
    },
    FONTS: {
        FONT_SIZE: 'fontSize',
        FONT: 'font',
    },
};

export const THEME_TITLES = {
    headerColor: 'Header Color',
    textColor: 'Text Color',
};

export const DEFAULT_FONT_SIZE = 12;
export const DEFAULT_FONT = 'Open Sans';
